import logo2020 from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2020.png";
import logo2021 from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2021.png";
import logo2022 from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2022.png";
import logo2023 from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2023.png";
import logo2024 from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2024.png";
import logo2025 from "../../assets/img/nxtEvents/LogoHalloweenHavoc/HalloweenHavoc2025.png";

export const nxtHalloweenHavocDetail = {
  "nxt-halloween-havoc": {
    id: "nxt-halloween-havoc",
    title: "NXT Halloween Havoc",
    subtitle: "Explore the event editions in a dedicated event view.",
    tabs: [
      {
        id: "editions",
        label: "Editions",
        variant: "nxt-halloween-havoc",
        items: [
          {
            id: "nxt-halloween-havoc-2020",
            title: "Halloween Havoc",
            description: "NXT special episode 2020",
            imgUrl: logo2020,
          },
          {
            id: "nxt-halloween-havoc-2021",
            title: "Halloween Havoc",
            description: "NXT special episode 2021",
            imgUrl: logo2021,
          },
          {
            id: "nxt-halloween-havoc-2022",
            title: "Halloween Havoc",
            description: "2022",
            imgUrl: logo2022,
          },
          {
            id: "nxt-halloween-havoc-2023",
            title: "Halloween Havoc",
            description: "NXT special episode 2023",
            imgUrl: logo2023,
          },
          {
            id: "nxt-halloween-havoc-2024",
            title: "Halloween Havoc",
            description: "2024",
            imgUrl: logo2024,
          },
          {
            id: "nxt-halloween-havoc-2025",
            title: "Halloween Havoc",
            description: "2025",
            imgUrl: logo2025,
          },
        ],
      },
    ],
  },
};
